export const MAX_MODAL_WIDTH = 534;
export const WELCOME_IMAGE_HEIGHT = 156;
